import { Component, AfterViewInit } from '@angular/core';
import { ITechnicalSkill } from '../../../Models/interfaces/ITechnicalSkill';
import { TechnicalSkills } from '../../../mock/technicalSkills.mockdata';

@Component({
  selector: 'app-technical-skills',
  templateUrl: './technical-skills.component.html',
  styleUrls: ['./technical-skills.component.css']
})
export class TechnicalSkillsComponent implements AfterViewInit {

  technicalSkills: ITechnicalSkill[] = TechnicalSkills;
  size = 10;

  // tslint:disable-next-line: typedef
  ngAfterViewInit() {
    setTimeout(() => {
      this.size = 200;
    }, 50);
  }

}
